import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space6, space8, colorBgBase, borderRadius4 } = theme();

  return StyleSheet.create({
    container: {
      backgroundColor: colorBgBase,
    },
    content: {
      paddingTop: space6,
    },
    largeContainer: {
      borderRadius: borderRadius4,
      marginTop: space8,
      padding: space8,
    },
  });
};

export { style };
